import React from "react";
//#region types
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { StaticInfoMessage, TitleSmall } from "components/common";
import useFileViewerContext from "components/common/fileViewer/context/useContext";
import AuditSheetDetailsView from "./auditSheetDetailsView";
import AuditSheetSummaryList from "./auditSheetSummaryList";
import { useAuditSheetNavigation } from "../hooks/auditSheetNavigationContext";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const AuditSheetNavigatedDetailsView: React.FC = () => {
  const { current, index } = useAuditSheetNavigation();
  const { setUploadedFileDimensions } = useFileViewerContext();

  // The dialog keeps its side offset for as long as the last file's size is known, also after that file is gone.
  React.useEffect(() => {
    if (current.auditSheetId === undefined) setUploadedFileDimensions(undefined);
  }, [index]);

  if (current.auditSheetId !== undefined) {
    return <AuditSheetDetailsView key={index} auditSheetId={current.auditSheetId} />;
  }

  return (
    <Grid item className={cssExports.auditSheetDetailsView} container rowGap={4}>
      <StaticInfoMessage fullWidth>
        {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Advisor.NoAccountSpecification)}
      </StaticInfoMessage>
      {current.balance !== undefined && (
        <Grid item container direction={"column"} gap={1}>
          <TitleSmall title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Advisor.Summation)} />
          <Grid item>
            <AuditSheetSummaryList
              items={[
                {
                  name: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Advisor.Balance),
                  value: current.balance,
                },
              ]}
            />
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default AuditSheetNavigatedDetailsView;
